import React, {useContext, useMemo} from "react";

// Components
import VideoContentGridLandscape from "../../Components/Layouts/Content/Watch/VideoFeed/VideoContentGridLandscape";
import ButtonPill from "../../Components/Buttons/ButtonPill";

// Hooks
import useFetchSpecificContentItems from "../../Hooks/Content/Watch/VideoSingle/useFetchSpecificContentItems";

// Context
import {GlobalInterfaceContext} from "../../Context/GlobalInterfaceContext";
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Constants
import {RoutePaths} from "../../Constants/RoutePaths";

const DavidIckeLive = () => {
    const
        { isDarkMode } = useContext(GlobalInterfaceContext),
        authCtx = useContext(UserAuthenticationContext),

        // User data
        userId = authCtx.userData?.id ?? "1c624ef2-27a9-496f-b518-6f6e612078b6",
        countryCode = "GB",

        filmsIds = useMemo(
            () => [
                { type: "Series", id: 181 },
                { type: "Series", id: 97 },
                { type: "Film", id: 40 },
                { type: "Series", id: 20 },
                { type: "Series", id: 19 },
                { type: "Series", id: 18 },
                { type: "Series", id: 16 },
                { type: "Film", id: 31 },
                { type: "Series", id: 17 },
                { type: "Series", id: 14 },
                { type: "Series", id: 28 },
                { type: "Film", id: 26 },
            ],
            []
        ),
        {
            items,
            loading,
            error
        } = useFetchSpecificContentItems(filmsIds, countryCode, userId);


    return (
        <div className="page page--david-icke page--david-icke-sub-page">
            <div className="david-icke__banner">
                <img src="https://storage.ickonic.com/IckonicImage/compressed/David Icke Header 04b.jpg" alt="David Icke - World Renowned Author and Researcher" />
            </div>

            <div className="page__heading">
                <h1>
                    David Icke Live
                </h1>

                <ButtonPill label="Back" link={RoutePaths.DavidIcke}/>
            </div>

            <VideoContentGridLandscape
                isDarkMode={isDarkMode}
                carouselItems={loading ? undefined : items}
                backgroundHex="#151515"
            />
        </div>
    )
}

export default DavidIckeLive;
